(function ($) {
        
    $.fn.AccordionToggle = function () {
        return $(this).each(function () {
            var container = $(this).closest('.accordion');
            var header = $(this);
            var icon = $(this).children('.cc');
            var collapsableContent = $('.expandable', container);

            header.click(function (event) {
                if (collapsableContent.hasClass('open')) {
                    collapsableContent.css('max-height', '0');
                    collapsableContent.removeClass('open');
                } else {
                    var height;
                    if (collapsableContent.data('myHeight')) {
                        height = collapsableContent.data('myHeight');
                    } else {
                        collapsableContent.css('max-height', 'none');
                        height = collapsableContent.outerHeight();
                        collapsableContent.css('max-height', '0');
                        collapsableContent.data('myHeight', height);
                    }
                    setTimeout(function () {
                        collapsableContent.addClass('open');
                        collapsableContent.css({
                            'max-height': height
                        });
                    }, 1);
                }
                icon.toggleClass('cc-minus cc-plus');
            });
        });
    };

    $(document).ready(function () {
        $('.accordion-header').AccordionToggle();
    });
}(jQuery));